// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hr_wrapper__2DgbQ","hr":"Hr_hr__13vbE","text":"Hr_text__3b_1K"};